










import GroupBuyingMore from '@/views/group_buying/components/more.vue'
import { defineClassComponent } from '@/hooks'
import { goodsProvider } from '../provider'

export default defineClassComponent(
  {
    components: {
      GroupBuyingMore,
    },
  },
  () =>
    class {
      // 商品数据
      goodsData = goodsProvider.inject()

      // 倒计时结束
      handleCountdownEnd = () => {
        this.goodsData.value.refreshMarketing()
      }
    },
)
